import { css, cx } from '@eti/styles';
import type { ReactNode } from 'react';
import type { HeadingTypes } from '@etg/wings';
import { Card, Heading, Inline, Stack, Text } from '@etg/wings';

const heightStyles = css`
  height: 100%;
`;

const wrapperStackStyles = (hasIcon: boolean) => css`
  flex: 1;
  height: 100%;
  padding-bottom: 16px;
  padding-inline: ${hasIcon ? '0' : '16px'} 16px;
  padding-top: 16px;
`;

interface BannerProps {
  cardClassName?: string;
  contentClassName?: string;
  'data-testid': string;
  description: string;
  footer: ReactNode;
  icon?: ReactNode;
  title: string;
  headingAs?: `h${HeadingTypes['level']}` | 'h5';
}

const Banner = ({
  cardClassName,
  contentClassName,
  'data-testid': dataTestId,
  description,
  footer,
  icon,
  title,
  headingAs = 'h2',
}: BannerProps) => {
  const hasIcon = Boolean(icon);

  return (
    <Card
      className={cx(heightStyles, cardClassName)}
      data-testid={`${dataTestId}-banner`}
      padding={0}
    >
      <Inline className={heightStyles} noWrap spacing={0}>
        {icon}
        <Stack
          align="start"
          className={cx(wrapperStackStyles(hasIcon), contentClassName)}
          data-testid={`${dataTestId}-banner-content`}
          spacing={8}
        >
          <Stack spacing={4}>
            <Heading as={headingAs} data-testid={`${dataTestId}-banner-title`} level={3}>
              {title}
            </Heading>
            <Text asHtml data-testid={`${dataTestId}-banner-description`}>
              {description}
            </Text>
          </Stack>
          {footer}
        </Stack>
      </Inline>
    </Card>
  );
};

export default Banner;
